export default "__VITE_ASSET__Bzf5fVVg__"